import React, {Fragment, useContext, useState} from 'react';
import {Form, FormGroup, Label} from 'reactstrap';
import Dropzone from 'react-dropzone-uploader';
import {Btn} from '../../../../AbstractElements';
import Loader from '../../../../Layout/Loader';
import AuthorizationContext from '../../../../_helper/Authorization';
import type {AuthorizationContextType} from '../../../../_helper/Authorization/AuthorizationTypes';
import MultimediaService from '../Services/Multimedia.service';
import type {Multimedia} from '../Types/MultimediaTypes';

interface MultimediaUploadFormProps {
    callBack?: (multimedia: Multimedia) => void;
}

const MultimediaUploadForm: React.FC<MultimediaUploadFormProps> = ({callBack}) => {
    const [loaderVisibility, setLoaderVisibility] = useState<boolean>(false);
    const [file, setFile] = useState<File | null>(null);
    const [dropzoneKey, setDropzoneKey] = useState<number>(0);
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const {errorHandler} = authContext || {};

    const getUploadParams = () => ({
        // autoUpload is disabled, so this URL is not used for posting.
        url: 'https://httpbin.org/post',
    });

    const handleChangeStatus = ({file: selectedFile}: any, status: string) => {
        if (status === 'removed') {
            setFile(null);
            return;
        }

        if (status === 'ready' || status === 'done' || status === 'headers_received') {
            setFile(selectedFile || null);
        }
    };

    const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (!file) return;

        setLoaderVisibility(true);
        MultimediaService.uploadMultimedia(file)
            .then((response) => {
                callBack?.(response);
                setFile(null);
                setDropzoneKey((currentValue) => currentValue + 1);
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception);
                setLoaderVisibility(false);
            });
    };

    return (
        <Fragment>
            <Form onSubmit={onSubmit}>
                <Loader visibility={loaderVisibility}/>
                <FormGroup>
                    <Label className='col-form-label m-0 required'>File</Label>
                    <Dropzone
                        key={dropzoneKey}
                        className='dropzone dz-clickable'
                        getUploadParams={getUploadParams}
                        onChangeStatus={handleChangeStatus}
                        maxFiles={1}
                        multiple={false}
                        canCancel={false}
                        autoUpload={false}
                        inputContent='Drop A File'
                        styles={{
                            dropzone: {width: '100%', height: 150},
                            dropzoneActive: {borderColor: 'green'},
                        }}
                    />
                    <small className='text-muted'>Selected files are uploaded and automatically marked as approved.</small>
                </FormGroup>
                <FormGroup>
                    <Btn attrBtn={{
                        className: 'd-block w-100 mt-4',
                        color: 'primary',
                        type: 'submit',
                        disabled: loaderVisibility || !file,
                    }}>
                        Upload File
                    </Btn>
                </FormGroup>
            </Form>
        </Fragment>
    );
};

export default MultimediaUploadForm;
